var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"main",staticClass:"mapManage",attrs:{"id":"main"}},[_c('iframe',{ref:"iframe",staticClass:"iframe",attrs:{"id":"iframe","frameborder":0,"src":"https://lyapp.gispai.com/cgDownload2"}})])}
var staticRenderFns = []

export { render, staticRenderFns }